import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';
import Avatar from '@material-ui/core/Avatar';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Divider from '@material-ui/core/Divider';
import ImageIcon from '@material-ui/icons/Image';

import { parseDateToStringFormat } from '../../utils/dateUtils';
import { SERVER_ADDR, USER_FILES_FOLDER } from '../../constants';

const styles = theme => ({
  card: {
    textAlign: 'center'
  },
  avatar: {
    backgroundColor: '#ff0000',
    margin: 'auto'
  },
  subheader: {
    textAlign: 'center',
    clear: 'both',
    display: 'block',
    marginRight: 0
  },
  light: {
    marginLeft: theme.spacing.unit * 3,
    marginRight: theme.spacing.unit * 3,
  }
});

function renderData(list, classes) {
  if (list.length < 1) {
    return 'No Reviews Found';
  }

  return list.map(l => {
    const user = l.userDetails || {};
    const userImage = user.image ? <Avatar
      alt="Profile Pic"
      src={`${SERVER_ADDR}public/assets/${USER_FILES_FOLDER}/${user.image}`}
      className={classes.avatar}
    /> : <ImageIcon />;

    return (
      <Grid item xs={12} sm={4}>
        <Card className={classes.card}>
          <CardHeader
            avatar={
              userImage
            }
            title={`${user.firstName} ${user.lastName}`}
            subheader={parseDateToStringFormat(l.createdAt)}
            className={classes.subheader}
          />
          <Divider light className={classes.light} />
          <CardContent>
            <Typography component="p">
              {l.content}
            </Typography>
          </CardContent>
        </Card>
      </Grid>
    );
  });
}

function UserReviews(props) {
  const {
    classes,
    list
  } = props;

  return (
    <Grid container spacing={24}>
      <Grid item xs={12}>
        <Typography variant="h5">User Reviews</Typography>
      </Grid>
      {renderData(list, classes)}
    </Grid>
  );
}

UserReviews.propTypes = {
  classes: PropTypes.object.isRequired,
  list: PropTypes.array,
  updateDakk: PropTypes.func,
  openView: PropTypes.func
};

UserReviews.defaultProps = {
  list: []
};

export default withStyles(styles)(UserReviews);